export default [
  {
    name: 'Agenda',
    icon: 'nc-icon nc-calendar-60',
    path: '/agenda'
  },
  {
    name: 'Clients',
    icon: 'nc-icon nc-single-02',
    path: '/clients'
  },
  {
    name: 'Commandes',
    icon: 'nc-icon nc-basket',
    path: '/commandes'
  },
  {
    name: 'Requêtes',
    icon: 'nc-icon nc-chat-33',
    path: '/requetes'
  },
  // {
  //   name: 'Statistiques',
  //   icon: 'nc-icon nc-chart-pie-36',
  //   path: '/stats'
  // },
  {
    name: 'Aides à la vente',
    icon: 'nc-icon nc-alert-circle-i',
    path: '/aides-ventes'
  },
]
